import {Grid} from '@mui/material';
import DotLoading from 'components/Loading/DotLoading';

const Loading = () => (
  <Grid
    item
    xs={12}
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
    <DotLoading />
  </Grid>
);

export default Loading;
